import React from 'react';
import { sections } from './FooterGridSectionRenderer';
import ContactSection from './ContactSection';
import Disclaimer from './DisclaimerSection';
import Section from './SectionRenderer';
import facebookIcon from '../../assets/images/footer/svg/Facebook.svg'
import twitterIcon from '../../assets/images/footer/svg/Twitter.svg'
import youtubeIcon from '../../assets/images/footer/svg/Youtube.svg'
import instagramIcon from '../../assets/images/footer/svg/Instagram.svg'
import linkedinIcon from '../../assets/images/footer/svg/LinkedIn.svg'

const Footer = () => {
    return (
        <footer className="footer bg-white text-black text-sm">
            <div className='bg-[#F5F5F5] px-10 pt-10 lg:px-20 lg:pt-20'>
                <div className='footer-main flex flex-col lg:flex-row gap-10'>
                    <div className='footer-contact flex flex-col lg:w-[20vw]'>
                        <p className='text-xs lg:text-base font-bold mb-2'>Follow Us</p>
                        <div className='flex flex-row gap-4 lg:mb-10'>
                            <a href="https://www.facebook.com/ManipalCignaHealthInsurance/" target='_blank'>
                                <img src={facebookIcon} alt="Facebook" />
                            </a>
                            <a href="https://twitter.com/ManipalCigna/" target='_blank'>
                                <img src={twitterIcon} alt="Twitter" />
                            </a>
                            <a href="https://www.youtube.com/@ManipalCignaHealthInsurance" target='_blank'>
                                <img src={youtubeIcon} alt="YouTube" />
                            </a>
                            <a href="https://www.instagram.com/manipalcigna_healthinsurance/" target='_blank'>
                                <img src={instagramIcon} alt="Instagram" />
                            </a>
                            <a href="https://www.linkedin.com/company/manipalcigna-health-insurance/mycompany/?viewAsMember=true" target='_blank'>
                                <img src={linkedinIcon} alt="LinkedIn" />
                            </a>
                        </div>
                        <ContactSection />
                    </div>
                    <div className="footer-sections grid grid-cols-1 lg:grid-cols-4 gap-x-4 gap-y-4 lg:gap-y-12">
                        {sections.map((section, index) => (
                            <Section key={index} title={section.title} links={section.links} />
                        ))}
                    </div>
                </div>
                <div className="footer-bottom bg-[#F5F5F5] lg:p-6 border-t-2 border-[#00000010]">
                    <div className="hidden lg:block text-xs text-black mt-6">
                        For all Terms & Conditions and Disclaimers, please{' '}
                        <a href="https://www.manipalcigna.com/disclaimer" className="text-[#F47C20] hover:underline">click here.</a>
                    </div>
                    <div className="hidden lg:block border-2 bg-[#F5F5F5] border-black mt-4 p-4 w-[50vw] mx-[22%]">
                        <Disclaimer />
                    </div>
                    <div className="hidden lg:block text-left text-xs mt-6 pb-4 border-b-2 border-{#00000010]">
                        This site best viewed using latest versions of Chrome, Firefox, Safari, Microsoft
                        Internet Explorer(10+) or a equivalent browser with a screen resolution of 1024 * 768
                        or higher. If your browser is of older version, you may have trouble viewing few of the
                        features on our website properly.
                    </div>
                    <div className="text-left lg:text-center text-xs mt-6 mb-4">
                        © 2019 ManipalCigna Health Insurance Company Limited. All rights reserved. Trade Name /
                        Trade Logo belongs to MEMG International India Private Limited and Cigna Intellectual
                        Property Inc and is being used by ManipalCigna Health Insurance Company Limited under
                        license. For more details on risk factors, terms and conditions, please read the sales
                        brochure/ sales document available on our website (Download section) before concluding
                        a sale.
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;